import { Box } from '@mui/material';

// ----------------------------------------------------------------------

type Props = {
  row: any;
};

// ----------------------------------------------------------------------

export function RowCellLabelColor({ row }: Props) {
  return (
    <Box
      sx={{
        height: 18,
        width: 18,
        borderRadius: '50%',
        background: 'labelColor' in row ? row.labelColor : 'transparent',
        transition: 'all 0.3s ease-in-out',
        '&:hover': {
          transform: 'scale(1.2)',
          boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
        },
      }}
    />
  );
}
